<template>
  <a-config-provider :locale="zhCN">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { initWeighConfigSync, syncWeighConfigNow } from '@/utils/weighDevice'

export default {
  name: 'App',
  data() {
    return { zhCN }
  },
  computed: {
    // [2026-08-17] 当前工厂 ID: 切厂时过磅设备配置按工厂隔离, 需要重新对账同步
    factoryId() {
      const s = this.$store && this.$store.state
      return (s && s.externalOrg && s.externalOrg.saleOrgId) || ''
    }
  },
  watch: {
    // [2026-08-17] 切厂 → 立即与新工厂维度的服务端配置对账（GlobalScaleBar 监听 synced 事件重新水合）
    factoryId(v, old) {
      if (v && v !== old) syncWeighConfigNow()
    }
  },
  created() {
    // [2026-08-17] 过磅设备配置同步好粮宝本地服务（离线时静默退化为纯 localStorage, 无感）
    initWeighConfigSync()
  }
}
</script>

<style lang="less">
#app {
  height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}
</style>
